import { Dialog } from '@mui/material';
import { useState } from 'react';

import { Box } from './Box';

interface LightboxProps {
  trigger: React.ReactNode;
  imageUrl: string;
  open?: boolean;
  onClose?: () => void;
}

export const Lightbox: React.FC<LightboxProps> = ({
  trigger,
  imageUrl,
  open: controlledOpen,
  onClose: controlledOnClose,
}) => {
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled =
    controlledOpen !== undefined && controlledOnClose !== undefined;
  const isOpen = isControlled ? controlledOpen : internalOpen;
  const handleClose = isControlled
    ? controlledOnClose
    : () => setInternalOpen(false);

  return (
    <>
      <Box
        onClick={() => setInternalOpen(true)}
        sx={{ display: 'inline-block', cursor: 'pointer', width: '100%' }}
      >
        {trigger}
      </Box>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        fullWidth
        maxWidth={false}
        onClick={handleClose}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            margin: 0,
            maxHeight: '100%',
            maxWidth: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          },
        }}
      >
        <Box
          component="img"
          src={imageUrl}
          onClick={(e) => {
            e.stopPropagation(); // Prevent double-closing
            handleClose();
          }}
          sx={{
            maxHeight: '90vh',
            maxWidth: '90vw',
            objectFit: 'contain',
            cursor: 'pointer',
          }}
        />
      </Dialog>
    </>
  );
};
